import { Inspector, Flex } from '@sequencehq/core-components'
import { FC, ReactNode } from 'react'
import { rilletIntegrationConfig } from '../rillet.integration.config'
import {
  LinkCustomerToServiceWidget,
  LinkProductWidget,
  LinkOrCreateProductModal
} from '../../common/LinkEntities'
import { LinkedInvoiceWidget } from '../../common/LinkEntities/LinkedInvoiceWidget/LinkedInvoiceWidget'
import { LinkedCreditNoteWidget } from '../../common/LinkEntities/LinkedCreditNoteWidget/LinkedCreditNoteWidget'
import { LinkOrCreateCustomerModal } from '../../common/LinkEntities/LinkCustomerToService/LinkOrCreateCustomerModal'
import { SmallIcon } from 'Integrations/integrationsConfig/common/SmallIcon'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { useIntegrationActive } from 'Integrations/utils/useIntegrationActive'

export const LinkRilletCustomerWidget: FC<{
  customerId: string
}> = props => (
  <LinkCustomerToServiceWidget
    customerId={props.customerId}
    sequenceEntityLabel="customer"
    externalEntityLabel="customer"
    service="Rillet"
    canUnlink={true}
    linkModal={linkProps => <LinkOrCreateCustomerModal {...linkProps} />}
  />
)

export const LinkRilletProductWidget: FC<{
  productId: string
}> = props => (
  <LinkProductWidget
    productId={props.productId}
    sequenceEntityLabel="product"
    externalEntityLabel="product"
    service="Rillet"
    canUnlink={false}
    linkModal={LinkRilletProductModal}
  />
)

const LinkRilletProductModal: FC<{
  productId: string
  onClose: () => void
}> = ({ productId, onClose }) => {
  return (
    <LinkOrCreateProductModal
      productId={productId}
      service="Rillet"
      externalEntityLabel="product"
      onClose={onClose}
    />
  )
}

export const LinkRilletInvoiceWidget: FC<{
  invoiceId: string
}> = props => (
  <LinkedInvoiceWidget invoiceId={props.invoiceId} service="Rillet" />
)

export const LinkRilletCreditNoteWidget: FC<{
  creditNoteId: string
}> = props => (
  <LinkedCreditNoteWidget creditNoteId={props.creditNoteId} service="Rillet" />
)

export const RilletInspectorItem: FC<{
  children: ReactNode
}> = props => {
  const flags = useFeatureFlags()
  const integrationActive = useIntegrationActive('Rillet')

  if (!flags.useRillet) return null
  if (!integrationActive) return null

  return (
    <Inspector.IconItem
      data-testid="Rillet.inspector.item"
      content={
        <Inspector.Content
          title="Rillet"
          icon={<SmallIcon url={rilletIntegrationConfig.smallLogoUrl} />}
          data-testid="Rillet.inspector.content"
        >
          <Flex flexDirection="column" gap="16px">
            {props.children}
          </Flex>
        </Inspector.Content>
      }
      tooltip="Rillet"
      icon={<SmallIcon url={rilletIntegrationConfig.smallLogoUrl} />}
    />
  )
}
